import { useAuthStore } from "@/store/useAuthStore";

const checkPermission = async (to, from, next) => {
    try {
        // Retrieve the user's permissions from the store
        const authStore = useAuthStore();
        const domainKey = window.location.origin.replaceAll('://', '').replaceAll('.', '');
        const user = JSON.parse(localStorage.getItem(`${domainKey}-user`)) || {};
        if (Object.keys(user).length === 0) {
            await authStore.fetchUser();
        }
        const userPermissions = await user.permissions.permissions || [];
        const requiredPermissions = to.meta.permissions || [];

        // If no specific permissions are required, allow access
        if (requiredPermissions.length === 0) {
            return next();
        }

        /**
         * Check if the user has all required permissions
         * Or if the user has the travel_admin permission
         */
        const hasPermission = requiredPermissions.every((permission) => {
            return userPermissions.includes(permission) || userPermissions.includes("travel_admin");
        });

        if (hasPermission) {
            next();
        } else {
            // Redirect to an unauthorized page
            next({ name: "forbidden" });
        }
    } catch (error) {
        next({ name: "NotFound" });
    }
};

export default checkPermission;